import type { TechniqueDefinition } from "./TechniqueDefinition.js";

export const dominioDasRaizes: TechniqueDefinition = {
  id: "dominio_das_raizes",
  name: "Domínio das Raízes",
  description:
    "Spreads energized roots across an area, dealing periodic technique damage and greatly reducing movement speed.",
  family: "elemental_ninjutsu",
  proficiency: "ninjutsu",
  targeting: "point_area",
  behavior: { kind: "field" },
  field: {
    kind: "persistent_field",
    durationMs: 8_000,
    pulseIntervalMs: 2_000,
    pulseCount: 4,
    activeLimitPerCaster: 1,
    recast: "replace",
    placement: "target_position",
  },
  levels: {
    1: {
      chakraCost: 30,
      cooldownMs: 12_000,
      range: 190,
      maxTargets: 5,
      power: 3,
      attackCoefficient: 0.2,
      radius: 68,
      fieldSlow: 0.18,
    },
    2: {
      chakraCost: 31,
      cooldownMs: 12_000,
      range: 190,
      maxTargets: 5,
      power: 3,
      attackCoefficient: 0.21,
      radius: 70,
      fieldSlow: 0.19,
    },
    3: {
      chakraCost: 32,
      cooldownMs: 12_000,
      range: 190,
      maxTargets: 5,
      power: 4,
      attackCoefficient: 0.22,
      radius: 72,
      fieldSlow: 0.2,
    },
    4: {
      chakraCost: 33,
      cooldownMs: 12_000,
      range: 190,
      maxTargets: 5,
      power: 4,
      attackCoefficient: 0.23,
      radius: 74,
      fieldSlow: 0.21,
    },
    5: {
      chakraCost: 34,
      cooldownMs: 12_000,
      range: 190,
      maxTargets: 5,
      power: 4,
      attackCoefficient: 0.25,
      radius: 76,
      fieldSlow: 0.23,
    },
    6: {
      chakraCost: 35,
      cooldownMs: 12_000,
      range: 190,
      maxTargets: 5,
      power: 5,
      attackCoefficient: 0.26,
      radius: 78,
      fieldSlow: 0.24,
    },
    7: {
      chakraCost: 36,
      cooldownMs: 12_000,
      range: 190,
      maxTargets: 5,
      power: 5,
      attackCoefficient: 0.27,
      radius: 80,
      fieldSlow: 0.26,
    },
    8: {
      chakraCost: 37,
      cooldownMs: 12_000,
      range: 190,
      maxTargets: 5,
      power: 5,
      attackCoefficient: 0.28,
      radius: 82,
      fieldSlow: 0.27,
    },
    9: {
      chakraCost: 38,
      cooldownMs: 12_000,
      range: 190,
      maxTargets: 5,
      power: 6,
      attackCoefficient: 0.29,
      radius: 83,
      fieldSlow: 0.29,
    },
    10: {
      chakraCost: 39,
      cooldownMs: 12_000,
      range: 190,
      maxTargets: 5,
      power: 6,
      attackCoefficient: 0.3,
      radius: 84,
      fieldSlow: 0.3,
    },
  },
  visual: {
    effectId: 230,
    castEffectId: null,
    fieldPulseEffectId: 230,
    impactEffectId: 230,
  },
};
